import { Anchor, Group } from '@mantine/core';

import { Project } from 'models';

import cx from './DesignLibraryTeaser.module.scss';

const DesignLibraryTeaserTags = ({
    project,
    handleTagClick,
}: {
    project: Project;
    handleTagClick?: (tag: string) => void;
}) => {
    if (!project.tags.length) {
        return null;
    }

    return (
        <Group gap={8} className={cx.tags}>
            {project.tags.map((tag) => (
                <Anchor
                    key={tag}
                    className={cx.tag}
                    component={handleTagClick ? 'a' : 'span'}
                    onClick={handleTagClick ? () => handleTagClick(tag) : undefined}
                    data-clickable={Boolean(handleTagClick)}
                >
                    {tag}
                </Anchor>
            ))}
        </Group>
    );
};

export { DesignLibraryTeaserTags };
